import { ConfirmModal, showToast } from "../primitives";
import type { LibraryNode } from "../../../lib/types";
import { useDemoteToFolder } from "../../../lib/hooks/use-kuvio";

interface DemoteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  node: Pick<LibraryNode, "id" | "name">;
}

/**
 * Sprint 5u — confirm demoting an agent to a folder. A reversible soft archive:
 * the persona is snapshotted to a recoverable reserve, children stay attached.
 */
export function DemoteModal({ open, onOpenChange, node }: DemoteModalProps) {
  const demote = useDemoteToFolder();

  return (
    <ConfirmModal
      open={open}
      onOpenChange={onOpenChange}
      title={`Demote ${node.name} to a folder?`}
      message={
        <>
          Demoting <strong>{node.name}</strong> archives its persona — instructions,
          configuration, and the references to its tasks and schedules — to a recoverable
          reserve. Child memories and pages stay attached; active schedules are disabled so
          the folder never auto-fires. The node becomes a folder.
          <br />
          <br />
          This is reversible: promote it back any time and choose <em>Restore previous persona</em>.
        </>
      }
      confirmLabel="Demote to folder"
      onConfirm={async () => {
        await demote.mutateAsync({ nodeId: node.id });
        showToast(`${node.name} is now a folder`);
      }}
    />
  );
}
